<template>
  <div>
    <div
      class="tables-navigation tables-navigation-full"
      :style="{ 'background-color': project.color || DEFAULT_COLOR }"
    >
      <div class="tab-wrap tab-wrap-summary spacex-8">
        <router-link
          to="active"
          :class="{ current: isCurrent('active') }"
          class="table-tab w-inline-block"
        >
          <div class="table-tab-text fw-5">
            {{ tenderStatuses['active'] }}
          </div>
          <div class="scew" />
        </router-link>
        <router-link
          to="archived"
          :class="{ current: isCurrent('archived') }"
          class="table-tab w-inline-block"
        >
          <div class="table-tab-text fw-5">
            {{ tenderStatuses['archived'] }}
          </div>
          <div class="scew" />
        </router-link>
      </div>
    </div>
    <div class="tables-actions-row">
      <div class="tables-actions spacex-16">
        <!--        <div class="py-6">-->
        <!--          <div class="flex-centering pointer">-->
        <!--            <SortIcon class="icon-16px" />-->
        <!--            <span class="ml-4 no-wrap fw-6">{{ $t('Sort') }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="py-6">
          <button id="create-new-tender" class="flex-centering pointer" @click="createTender">
            <PlusIcon class="icon-16px primary-icon p-3" />
            <span class="ml-4 no-wrap primary fw-5 unselectable">
              {{ $t('Create new tender') }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PlusIcon from '@/assets/icons/plus.svg';
  import { DEFAULT_COLOR } from '@/utils/constants/common';
  import createTender from '@/utils/mixins/create-tender';
  import { mapState } from 'vuex';

  export default {
    name: 'TendersNavigation',
    components: {
      PlusIcon,
    },
    mixins: [createTender],
    props: {
      project: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        DEFAULT_COLOR,
      };
    },
    computed: {
      ...mapState('global', ['tenderStatuses']),
    },
    methods: {
      isCurrent(status) {
        return this.$route.params.status === status;
      },
    },
  };
</script>
